import { LOANS } from 'loans.module/common/domain/constants.loans.js';
import MenuFamilyNeedALoanFormatter from './menuFamilyNeedALoan.formatter';
class MenuFamilyNeedALoanController {
  constructor($scope, $log, LoansUserDataService, LoansOperationsService, loadingMobileService, myLoansService) {
    'ngInject';
    this.scope = $scope;
    this.log = $log;
    this.loansUserDataService = LoansUserDataService;
    this.loansOperationsService = LoansOperationsService;
    this.loadingMobileService = loadingMobileService;
    this.myLoansService = myLoansService;
    this.simulationWitness = false;
    this.data = null;
    this.loaded = false;
    this.userId = this.loansUserDataService._employee.userId;
    this.initialCharges = 0; 
  }

  $onInit() {
    this.scope.$watch(() => this.itemSelected, item => this.getInitialFam(item));
    this.scope.$watch(() => this.optionFamilySelected, item => this.getInitialCateg(item)
    );

    this.loadingMobileService.show();
    this.loansOperationsService
      .getCreditworthiness(this.userId)
      .then(creditworthiness => {
        this.simulationWitness = creditworthiness.simulationWitness;
        const creditworthinessPayload = {
          raw: creditworthiness,
          simulatedLimits: [
            creditworthiness.socialHousingLoanSimulated,
            creditworthiness.socialHousingLoanFixedSimulated,
            creditworthiness.agreementHousingLoanSimulated,
            creditworthiness.agreementHousingLoanFixedSimulated
          ]
        };
        this.data = new MenuFamilyNeedALoanFormatter(creditworthinessPayload).format();
        this.loaded = true;
      })
      .catch(err => {
        this.log.error('Error en getCreditworthiness:', err);
      })
      .finally(() => {
        this.loadingMobileService.hide();
      });

    this.loadInitialCharges();
  }
  
  loadInitialCharges() {
    const employeeId = this.loansUserDataService._employee.userId;
    this.myLoansService
      .getMyLoans(employeeId)
      .then(loansList => {
        const loan = loansList.find(l =>
          (l.modalityCode === 'SV' || l.modalityCode === 'CV')
          && l.amortizable === true
        );
        this.initialCharges = loan ? loan.amountPending : 0;

      })
      .catch(err => {
        this.log.error('Error fetching myLoans:', err);
      });
  }

  onSelectFamily($event) {
    this.optionsFamiliesToSelect = [];
    this.selectFamily({ $event: { fam: $event.$item.value } });
  }

  onSelectCategoryFamily($event) {
    this.onSelectOptionFamily(
      {
        $event: {
          codeOptionSelected: $event.$item.value,
          codeLoanSimulation: `${$event.$item.value}${this.families[this.itemSelected].code}`,
        },
      });
  }

  showOptionsFamily() {
    if (this.isMobileApp) return false;
    return this.itemSelected !== undefined && this.itemSelected !== null;
  }

  getInitialFam(item) {
    if (!this.isMobileApp || item === undefined) return;
    this.initialFam = this.familiesMobile.filter(fam => fam.value === item);
    this.initialFam = this.initialFam[0];
  }

  isFamilySelected() {
    const isOptionSelected = (this.codeOptionSelected === undefined || this.codeOptionSelected === null);
    return this.optionsFamiliesToSelect === undefined && isOptionSelected;
  }

  getInitialCateg(item) {
    if (!this.isMobileApp || item === undefined) return;
    this.initialCateg = this.getCategorySelected();
  }

  getCategorySelected() {
    let purposesCategory = this.families[this.itemSelected].purposes;
    let categorySelected = purposesCategory.find(item => {
      if (item.purposeCode === this.codeOptionSelected) {
        return item;
      }
    });

    if (!categorySelected) return;
    return {
      value: categorySelected.purposeCode,
      option: categorySelected.purposeLiteral,
    };
  }

  shouldShowMessageWarning() {
    return this.housingWitness && !this.simulationWitness && this.codeOptionSelected == LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
  }

  shouldShowCreditCapacitySimulation() {
    return this.simulationWitness && this.codeOptionSelected == LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
  }

  isHousingMandatoryPurpose() {
    return this.codeOptionSelected == LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE;
  }

  shouldRemoveBorderBottom() {
    return { 'remove-border': this.selectedOptionFamily && this.codeOptionSelected != LOANS.ID_HR.HOUSING_MANDATORY_PURPOSE };
  }
}

export default MenuFamilyNeedALoanController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/menuFamilyNeedALoan/menuFamilyNeedALoan.controller.js